<script lang="ts">
import {defineComponent} from 'vue'

export default defineComponent({
  name: "FreeDaysOverlay",
  setup(props) {
    const freeDay = props.freeDay;
    const header = props.header;
    return {freeDay, header}
  },
  props: {
    freeDay: {
      type: Object,
      default: null,
    },
    header: {
      type: String,
      default: 'Freie Tage Eingabe'
    }
  },
  methods: {
    onCancel() {
      this.$emit('freedays-back', false);
    }
  }
})
</script>

<template>
  <v-container class="container py-6 d-flex align-center justify-center bg-white flex-column">
    <h3 class="mb-8">{{header}}</h3>
    <v-row class="w-100">
      <v-col>
        <v-text-field readonly v-model="freeDay.name"></v-text-field>
      </v-col>
    </v-row>
    <v-row class="w-100">
      <v-col class="mx-4">
        <v-text-field label="Maximum" v-model="freeDay.max"></v-text-field>
      </v-col>
    </v-row>
    <v-row>
      <v-col>
        <v-btn @click="onCancel">Zurück</v-btn>
      </v-col>
    </v-row>
  </v-container>  
</template>

<style scoped>
.container {
  border-radius: 5px;
  background: white;
}
</style>